<template>
    <div class="content">
        <div class="col-sm-6 text-left">
            <h2 class="card-title">TABLEAU DE BORD DE PERFORMANCE</h2>
        </div>

        <div class="row">
            <div class="col-12">
                <h4 class="card-title float-right mb-1">
                    Total des contacts <b>{{ totalContact }}</b>
                </h4>
            </div>
            <div class="col-12">
                <h4 class="card-title float-right mb-1">
                    CA mois en cours <b v-if="ca_mois_actuel">{{ formatThounsends(ca_mois_actuel, true, 2) }} €</b>
                </h4>
            </div>
            <div class="card card-chart">
                <div class="card-header row">
                    <div class="col-sm-6 text-left">
                        <h2 class="card-title">RATIO LTV/CAC</h2>
                    </div>

                    <div class="col-md-6 float-right">
                        <div class="btn-group btn-group-toggle float-right">
                            <button
                                class="btn btn-round btn-just-icon btn-danger"
                                :disabled="chartArray.length <= 1 || loading"
                                @click="removeChart"
                            >
                                -
                            </button>

                            <base-button
                                v-if="loading"
                                loading
                                class="btn btn-round btn-just-icon btn-primary"
                                disabled
                            >
                                {{ $t("buttons.BtnLoad").toUpperCase() }}
                            </base-button>

                            <base-button
                                v-else
                                class="btn btn-round btn-just-icon btn-primary"
                                disabled
                            >
                                {{ $t("comparer").toUpperCase() }}
                            </base-button>

                            <button
                                class="btn btn-round btn-just-icon btn-success"
                                :disabled="chartArray.length >= 6 || loading"
                                @click="addChart"
                            >
                                +
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- optimisation -->
            <card>
                <div class="row">
                    <div
                        v-for="(chartData, index) in chartArray"
                        :key="index"
                        :class="{
                            'col-12':
                                chartArray.length % 2 !== 0 &&
                                index === chartArray.length - 1,
                            'col-sm-12 et col-md-6':
                                chartArray.length % 2 === 0 ||
                                index < chartArray.length - 1,
                        }"
                    >
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-3 col-md-3">
                                    <base-input>
                                        <el-select
                                            class="select-primary"
                                            id="dates-select"
                                            :disabled="loading"
                                            placeholder="Choisissez"
                                            v-model="chartData.selectedYear"
                                            @change="
                                                handleYearChangeGraph(index)
                                            "
                                        >
                                            <el-option
                                                v-for="option in dates.listeDates"
                                                :key="option"
                                                :value="option"
                                                :label="option.toUpperCase()"
                                                class="select-option"
                                            />
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-lg-3 col-md-3">
                                    <base-input>
                                        <el-select
                                            class="select-primary"
                                            v-model="chartData.selectedProduct"
                                            @change="
                                                handleYearChangeIndex(index)
                                            "
                                            placeholder="Tous les produits"
                                        >
                                            <el-option
                                                v-for="product in products.Listproduct"
                                                :key="product.value"
                                                :label="
                                                    product.label.toUpperCase()
                                                "
                                                :value="product.value"
                                            />
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-lg-3 col-md-3">
                                    <base-input>
                                        <el-select
                                            class="select-primary"
                                            v-model="
                                                chartData.selectedOperation
                                            "
                                            @change="
                                                handleYearChangeIndex(index)
                                            "
                                            placeholder="Toutes les opérations"
                                        >
                                            <el-option
                                                v-for="type_op in operations.Listoperation"
                                                :key="type_op.value"
                                                :label="
                                                    type_op.label.toUpperCase()
                                                "
                                                :value="type_op.value"
                                            />
                                        </el-select>
                                    </base-input>
                                </div>
                                <div class="col-lg-3 col-md-3">
                                    <base-input>
                                        <el-select
                                            class="select-primary"
                                            v-model="chartData.levier"
                                            @change="
                                                handleYearChangeIndex(index)
                                            "
                                            placeholder="Tous les leviers"
                                        >
                                            <el-option
                                                v-for="levier in levier.ListLevier"
                                                :key="levier.value"
                                                :label="
                                                    levier.label.toUpperCase()
                                                "
                                                :value="levier.value"
                                            />
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="chart-container">
                                <!-- <div
                                    class="chart-area"
                                    v-if="!loading"
                                >
                                    <p>
                                        Moyenne LTV/CAC :
                                        <b>{{ moyenne_LTV_CAC[index] }}</b>
                                    </p>
                                    <p>
                                        Moyenne CA   :
                                        <b>{{ moyenne_total_LTV[index] }} €</b>
                                    </p>
                                    <div class="row">
                                        <div class="col-12">
                                            <base-button style="float: right;" @click="expandGraphChart(index)" class="btn-link" type="market" size="sm" icon>
                                                <i :class="[chartData.isExpanded ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
                                            </base-button>
                                        </div>
                                    </div>
                                    <div class="chart-legend"></div>

                                    <mixedChartData1
                                        :ref="'chartRef' + index"
                                        :chart-data="chartData.mixedChartData"
                                        :options="chartOptions1"
                                        class="mix"
                                    />
                                </div> -->
                                <div v-if="!loading" class="chart-area">
                                    <!-- Conteneur des informations (Moyenne LTV/CAC et Moyenne CA) et du graphique -->
                                    <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                                        <!-- Informations : Moyenne LTV/CAC et Moyenne CA -->
                                        <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                                        <p style="margin: 0;">
                                            Moyenne LTV/CAC :
                                            <b>{{ moyenne_LTV_CAC[index] }}</b>
                                        </p>
                                        <p style="margin: 0;">
                                            Moyenne CA :
                                            <b>{{ moyenne_total_LTV[index] }} €</b>
                                        </p>
                                        </div>

                                        <!-- Bouton d'extension du graphique aligné à droite -->
                                        <div>
                                        <base-button @click="expandGraphChart(index)" class="btn-link" type="market" size="sm" icon>
                                            <i :class="[
                                            chartData.isExpanded ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large'
                                            ]"></i>
                                        </base-button>
                                        </div>
                                    </div>

                                    <!-- Graphique -->
                                    <div class="chart-legend"></div>
                                    <mixedChartData1
                                        :ref="'chartRef' + index"
                                        :chart-data="chartData.mixedChartData"
                                        :options="chartOptions1"
                                        class="mix"
                                    />
                                    </div>
                                    <div class="chart-area" v-else>
                                    <div
                                        v-loading="true"
                                        class="h-100 d-flex justify-content-between align-items-center py-3"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>

            <!-- el table -->

            <div class="card card-chart">
                <div class="card-header">
                    <div class="col-sm-12 text-left">
                        <h2 class="card-title">
                            Liste des contacts :
                            <b> {{ this.totalContactsByYear }} </b>
                        </h2>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-3">
                            <div id="card-bodydate">
                                <base-input>
                                    <el-select
                                        class="select-primary"
                                        id="dates-select"
                                        :disabled="!lowder"
                                        placeholder="Choisissez"
                                        v-model="dates.selectedYear"
                                        @change="handleYearChange"
                                    >
                                        <el-option
                                            v-for="option in dates.listeDates"
                                            :key="option"
                                            :value="option"
                                            :label="option.toUpperCase()"
                                            class="select-option"
                                        />
                                    </el-select>
                                </base-input>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3">
                            <div id="card-bodydate">
                                <base-input>
                                        <el-select
                                            class="select-primary"
                                            v-model="contactSelectedProduct"
                                            @change="handleProductChange"
                                            placeholder="Tous les produits"
                                            :disabled="!lowder"
                                        >
                                            <el-option
                                                v-for="product in products.Listproduct"
                                                :key="product.value"
                                                :label="
                                                    product.label.toUpperCase()
                                                "
                                                :value="product.value"
                                            />
                                        </el-select>
                                </base-input>
                            </div>
                        </div>
                    </div>
                    <div v-loading="!lowder" class="loading-container">
                        <div class="row">
                            <div class="col-md-4 float-left" id="pagination">
                                <base-input>
                                    <el-select
                                        class="select-primary pagination-select"
                                        v-model="pagination.perPage"
                                        placeholder="Per page"
                                        @change="paginateContacts"
                                    >
                                        <el-option
                                            class="select-primary"
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <div class="col-lg-4 col-md-4" id="search">
                                <base-input>
                                    <el-input
                                        type="search"
                                        class="mb-3 search-input float-right"
                                        prefix-icon="el-icon-search"
                                        v-model="searchEmail"
                                        placeholder="Rechercher par email"
                                        @input="handleInputChange"
                                    >
                                        <template slot="suffix">
                                            <el-icon
                                                v-if="searchEmail"
                                                @click="
                                                    () => searchByEmail(true)
                                                "
                                                style="cursor: pointer"
                                            >
                                                <i
                                                    class="el-icon-check"
                                                    style="color: green"
                                                ></i>
                                            </el-icon>
                                        </template>
                                    </el-input>
                                </base-input>
                            </div>
                        </div>
                        <div class="table">
                            <el-table
                            :data="contactsData"
                            :disabled="loading"
                            @expand-change="handleExpandChange"
                            row-class-name="booking-table-rows"
                            class="customtable_cmd"
                            style="width: 100%"
                            :row-key="row => row.email"
                            :expand-row-keys="[expandedRow]"

                        >
                            <el-table-column
                                class-name="index-column"
                                type="index"
                                label="#"
                                width="65"
                                cell-class-name="text-muted"
                            />

                            <el-table-column type="expand">
                                <template scope="scope">
                                    <div class="d-flex flex-column align-items-center">
                                        <div class="table w-100">
                                            <el-table
                                                :data="filterDepenses(scope.row.depenses)"
                                                class="mb-3"
                                                :fit="true"
                                                style="width: 100%; border: 1px solid rgba(255, 255, 255, 0.1);"
                                            >
                                                <el-table-column
                                                    prop="provenance"
                                                    label="Provenance"
                                                    min-width="50"
                                                />
                                                <el-table-column
                                                    prop="prix"
                                                    label="Prix"
                                                    min-width="25"
                                                >
                                                    <template slot-scope="props">
                                                        {{ formatThounsends2(props.row.prix, true, 2) + " €" }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    prop="date_operation"
                                                    :formatter="formatDate1('date_operation')"
                                                    label="Date"
                                                    min-width="25"
                                                />
                                            </el-table>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center my-3 text-muted w-100">
                                            <span> {{ fromDepenses + 1 }} to {{ toDepenses }} of {{ totalDepenses }} entries</span>
                                            <base-pagination
                                                v-model="paginationDepenses.currentPage"
                                                :per-page="paginationDepenses.perPage"
                                                :total="totalDepenses"
                                            ></base-pagination>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                label="Email"
                                prop="email"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span
                                        @click="
                                            handleEmailClick(scope.row.email)
                                        "
                                        style="
                                            cursor: pointer;
                                            color: darkgrey;
                                            text-decoration: underline;
                                        "
                                    >
                                        {{ scope.row.email }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="CAC" prop="cac" sortable>
                                <template slot-scope="props">
                                    {{
                                        formatThounsends(
                                            props.row.cac,
                                            true,
                                            2
                                        ) + " €"
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column label="LTV" prop="ltv" sortable>
                                <template slot-scope="props">
                                    {{
                                        formatThounsends(
                                            props.row.ltv,
                                            true,
                                            2
                                        ) + " €"
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="LTV/CAC"
                                prop="ltv_cac_ratio"
                                sortable
                            >
                                <template slot-scope="props">
                                    {{
                                        formatThounsends(
                                            props.row.ltv_cac_ratio,
                                            true,
                                            2
                                        )
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="interactions"
                                prop="nombre_interactions"
                                sortable
                                class="text-center"
                            >
                                <template slot-scope="props">
                                    {{ props.row.nombre_interactions }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="jours"
                                prop="nombre_jours"
                                sortable
                                class="text-center"
                            >
                                <template slot-scope="props">
                                    {{ props.row.nombre_jours }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="MAJ Date d'acquisition"
                                :formatter="formatDate1('acquisition')"
                                prop="acquisition"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="MAJ Date de bénéfice"
                                :formatter="formatDate2('date_benefice')"
                                prop="date_benefice"
                                sortable
                            ></el-table-column>
                        </el-table>
                        </div>
                        <div
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        >
                            <div></div>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total"
                                @current-change="handlePageChange"
                            ></base-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="app">
    <!-- Vos autres composants -->
    <ChatWidget v-if="allowChatBot" />
  </div>
    </div>
</template>

<script>
import axios from "axios";
import { ElIcon } from "element-ui";
import { Button, Select, Option } from "element-ui";
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "src/components";
import { Bar, Line, mixins } from "vue-chartjs";
import moment from "moment";
import ChatWidget from './ChatWidget.vue'
moment.locale("fr");

const { reactiveProp } = mixins;
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        ChatWidget,

        mixedChartData1: {
            extends: Bar,
            mixins: [reactiveProp],
            props: ["options"],
            mounted() {
                /* console.log('mixedChartData1')
                console.log(this.options) */
                this.renderChart(this.chartData, this.options);
            },
        },
    },
    data() {
        return {
            contactSelectedProduct:"",
            expandedRow: '',
            paginationDepenses: {
                currentPage: 1,
                perPage: 10
            },
            totalDepenses: 0,
            allowChatBot:false,
            ca_mois_actuel:0,
            moyenne_total_LTV:[],
            allData:[],
            maxValue:0,
            maxValueActuel:0,
            currentData: null,
            mixedChartData: null,
            testFata: null,
            chartArray: [
                {
                    index: 0,
                    selectedYear: new Date().getFullYear(),
                    //selectedYear: 2023,
                    selectedProduct: "",
                    selectedOperation: "",
                    selectedLevier: "",
                    mixedChartData: null,
                    loading: false,
                    contacts: null,
                    moyenneLtvCac: null,
                    isExpanded:false,
                    maxValue:0
                },
            ],
            chartArrayGlobal: [],
            i: 1,
            totalContact: "",
            totalContactsByYear: "",
            loading: false,

            // enableButton: false,
            activeChart: 1,
            // selectedYear: null,
            contactsData: [],
            allContactsData: [],
            //  debounceTime: 3000, // 3 secondes pour les tests, ajustez selon besoin
            fetchContactsDebounced: null,
            yearsList: [],
            contacts: [],
            mixe2: [],
            mixe3: [],
            mixe4: [],
            searchEmail: "",
            filteredContacts: [],
            moyenne_LTV_CAC: [],
            currentYear: new Date().getFullYear(),
            dates: {
                selectedYear: new Date().getFullYear(),
                selectedYear1: new Date().getFullYear(),
                selectedYear2: new Date().getFullYear(),
                selectedYear3: new Date().getFullYear(),
                selectedYear4: new Date().getFullYear(),
                selectedYear5: new Date().getFullYear(),
                selectedYear6: new Date().getFullYear(),
                listeDates: [],
            },

            products: {
                Listproduct: [
                    { value: "Tous", label: "Tous les produits" },
                    { value: "sante", label: "Mutuelle santé" },
                    { value: "animaux", label: "Assurance Animaux" },
                    { value: "auto", label: "Assurance Auto" },
                    { value: "mrh", label: "Assurance Habitation" },
                    { value: "emprunteur", label: "Assurance Emprunteur" },
                    { value: "credit_conso", label: "Crédit Consommation" },
                    { value: "per", label: "Plan d'épargne Retraite" },
                ],
            },
            operations: {
                Listoperation: [
                    { value: "Tout", label: "Toutes les opérations" },
                    { value: "mer", label: "mer" },
                    { value: "vente", label: "vente" },
                ],
            },
            levier: {
                ListLevier: [
                    { value: "", label: "Tous les leviers" },
                    { value: "perf", label: "PERF" },
                    { value: "facebook", label: "FACEBOOK" },
                    { value: "google", label: "GOOGLE" },
                    { value: "bing", label: "BING" },
                    { value: "sms", label: "SMS" },
                ],
            },
            newChartData: null,

            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 20, 50, 100],
                total: 0,
                lastPage: 1,
            },
            chartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            type: "linear",
                            display: true,
                            position: "left",
                            id: "y-axis-1",
                            ticks: {
                                min: 0,
                               // suggestedMax: 400000,
                            },
                        },
                        {
                            type: "linear",
                            display: true,
                            position: "right",
                            id: "y-axis-2",
                            gridLines: {
                                drawOnChartArea: false,
                            },
                            ticks: {
                                min: 0,
                            },
                        },
                    ],
                },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            // Return the month as the title
                            return data.labels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            //console.log(tooltipItem)
                            const datasetLabel =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            const value = tooltipItem.yLabel.toFixed(2); // Format the value with two decimal places
                            return datasetLabel == "LTV/CAC"
                                ? `${datasetLabel}: ${value} `
                                : `${datasetLabel}: ${value} €`; // Add euro symbol
                        },
                    },
                },
                annotation: {
                    annotations: [
                        {
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-2",
                            value: 1.0,
                            borderColor: "red",
                            borderWidth: 2,
                            label: {
                                enabled: false,
                            },
                        },
                    ],
                },
            },

            lowder: false,
            leads: [],
            mixedChartData1: null,
            maxCharts: 5,
        };
    },
    computed: {
        fromDepenses() {
            return this.paginationDepenses.perPage * (this.paginationDepenses.currentPage - 1);
        },
        toDepenses() {
            let highBound = this.fromDepenses + this.paginationDepenses.perPage;
            if (this.totalDepenses < highBound) {
                highBound = this.totalDepenses;
            }
            return highBound;
        },
        sortedDepenses() {
            return (depenses) => {
                if (!depenses) return [];
                return [...depenses].sort((a, b) => new Date(b.date_operation) - new Date(a.date_operation));
            };
        }
    },
    methods: {
        handleExpandChange(row, expanded) {
            if (expanded) {
                this.expandedRow = row.email;
                this.paginationDepenses.currentPage = 1;
            } else {
                this.expandedRow = '';
            }
        },
         filterDepenses(depenses) {
            if (!depenses) return [];
            this.totalDepenses = depenses.length;
            const sorted = this.sortedDepenses(depenses);
            return sorted.slice(this.fromDepenses, this.toDepenses);
        },
        expandGraphChart(index){
            this.chartArray[index].isExpanded = !this.chartArray[index].isExpanded
            if(this.chartArray[index].isExpanded){
                this.chartOptions1.scales.yAxes[0].ticks.suggestedMax = this.chartArray[index].maxValue
            }else{
                this.chartOptions1.scales.yAxes[0].ticks.suggestedMax = this.maxValue
            }
            this.updateChart(index,  this.chartArray[index]);
        },
        updateAllCharts() {
            this.chartArray.forEach((chartData, index) => {
            // Récupérer la référence dynamique de chaque graphique
            const chartRef = this.$refs['chartRef' + index];
            //console.log(chartRef);
            if (chartRef) {
                if(chartRef.length>0){
                // Re-render chaque graphique avec les nouvelles données
                chartRef[0].renderChart(chartData.mixedChartData, this.chartOptions1);
                }
            }
            });
        },
        updateChart(index, chartData) {
            // Récupérer la référence du graphique en question
            const chartRef = this.$refs['chartRef' + index];
            if (chartRef) {
                // Re-render le graphique avec les nouvelles données
                chartRef[0].renderChart(chartData.mixedChartData, this.chartOptions1);
            } else {
                console.error(`Graphique avec l'index ${index} introuvable.`);
            }
        },
        handleYearChangeGraph(index){
            this.chartArray[index].selectedProduct = "";
            this.chartArray[index].selectedOperation = "";
            this.chartArray[index].levier = "";
            this.handleYearChangeIndex(index);

        },
        fetchChartAllData() {
            const apiUrl = `https://apileadmarket.wee-do-it.net/api/get_gains_depenses_by_provenance_allData`;
            const accessToken = localStorage.getItem("token_jwt");

            return axios
                .get(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
                .then((response) => {
                    this.loading = false;
                     /* console.log('response.data["2022"]') ;
                    console.log(response.data.data[0]['2022']) ; */
                    const dataByYear = response.data.data;

                    // Parcourir toutes les années
                    dataByYear.forEach((yearData) => {
                    // Extraire l'année et ses données associées
                    const year = Object.keys(yearData)[0];
                    const data = yearData[year].data;
                    this.allData[year] = data;

                    });

                    this.handleYearChangeIndex(0);
                }) // Retourne directement les données
                .catch((error) => {
                    this.loading = false;
                    console.error("Error fetching data:", error);
                    throw error; // Relance l'erreur pour gestion externe
                });
        },
        calculateDateDifference(dateStart, dateEnd) {
            if (dateStart && dateEnd) {
                const start = new Date(dateStart);
                const end = new Date(dateEnd);
                const diffTime = Math.abs(end - start);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                return diffDays;
            }
            return 0; // ou toute autre valeur par défaut si une des dates est manquante
        },
        paginateContacts() {
            const start =
                (this.pagination.currentPage - 1) * this.pagination.perPage;
            const end = start + this.pagination.perPage;
            this.contactsData = this.allContactsData
                .slice(start, end)
                .map((contact) => ({
                    ...contact,
                    ltv_cac_ratio: contact.cac ? contact.ltv / contact.cac : 0, // Calculer le ratio
                    nombre_jours: this.calculateDateDifference(
                        contact.acquisition_global,
                        contact.date_benefice
                    ), // Calculer le ratio
                }));
        },

        formatThounsends: function (value, fixe = false, number = 0) {
            if (value) {
                value = value.toFixed(number);
            }else{
                value = 0
            }
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatThounsends2: function (value, fixe = false, number = 0) {
            let prix = Number(value)
            if (prix) {
                prix = prix.toFixed(number);
            }else{
                prix = 0
            }
            return prix.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },

        addChart() {
            /* console.log('this.chartArray.length', this.chartArray.length)
            console.log('this.i', this.i) */
            let element = {
                index: this.i,
                //selectedYear: this.currentYear,
                selectedYear: new Date().getFullYear(),
                selectedProduct: "",
                selectedOperation: "",
                selectedLevier: "",
                mixedChartData: null,
                loading: false,
                contacts: null,
                moyenneLtvCac: null,
                isExpanded:false,
                maxValue:0
            };
            this.chartArray.push(element);

            this.handleYearChangeIndex(this.i);
            this.i = this.i + 1;
        },

        removeChart() {
            if (this.chartArray.length > 0) {
                this.chartArray.pop();
                this.i = this.i - 1;
            }
        },
        fetchContacts(isEmailSearch = false) {
            this.lowder = false;
            //const apiUrl = "https://apileadmarket.wee-do-it.net/api/get_contacts_infos";
            const apiUrl =
                "https://apileadmarket.wee-do-it.net/api/get_contacts_infos_v2";
            //const apiUrl = "https://apileadmarket.wee-do-it.net/api/get_contacts_infos";
            const accessToken = localStorage.getItem("token_jwt");

            const requestBody = {
                annee: this.dates.selectedYear,
                version: 2,
            };

            // Inclure l'email dans le corps de la requête si c'est une recherche par email
            if (isEmailSearch && this.searchEmail) {
                requestBody.email = this.searchEmail.trim();
            }
            const type_produit = this.contactSelectedProduct == "Tous" ? "" : this.contactSelectedProduct
            if (type_produit) {
                console.log("this.contactSelectedProduct", this.contactSelectedProduct)
                requestBody.type_produit =  type_produit;
            }

            axios
                .post(apiUrl, requestBody, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
                .then((response) => {
                    if (
                        response.data &&
                        response.data.contacts &&
                        Array.isArray(response.data.contacts)
                    ) {
                        // Mettre à jour toutes les données de contact avec la réponse de l'API
                        this.allContactsData = response.data.contacts;
                        this.totalContact = response.data.total_contacts;
                        this.totalContactsByYear =
                            response.data.totalContactsByYear;

                        if (isEmailSearch && this.searchEmail) {
                            //this.dates.selectedYear = response.data.contacts[0]

                            // Vérifier si l'email est dans les données nouvellement récupérées
                            const filteredApiData = this.allContactsData.filter(
                                (contact) =>
                                    contact.email
                                        .toLowerCase()
                                        .includes(
                                            this.searchEmail.toLowerCase()
                                        )
                            );

                            if (filteredApiData.length > 0) {
                                // Si l'email existe dans les données récupérées par l'API
                                this.contactsData = filteredApiData;
                            } else {
                                // Gérer le cas où l'email n'est pas trouvé dans la réponse de l'API
                                console.warn(
                                    "Email not found in the API response."
                                );
                                this.contactsData = []; // Effacer les données
                            }
                        } else {
                            // Pas de recherche spécifique par email, utiliser tous les contacts récupérés
                            this.contactsData = [...this.allContactsData];
                        }

                        // Limiter les résultats paginés
                        this.contactsData = this.contactsData.slice(
                            0,
                            this.pagination.pageSize
                        );
                        this.updatePagination();
                        this.paginateContacts();
                    } else {
                        console.error(
                            "Invalid response structure:",
                            response.data
                        );
                    }
                    this.lowder = true;
                })
                .catch((error) => {
                    this.lowder = true;
                    console.error(
                        "Erreur lors de la récupération des contacts :",
                        error
                    );
                });
        },

        updatePagination() {
            if (this.allContactsData && Array.isArray(this.allContactsData)) {
                // Calculate the total number of items for pagination
                this.pagination.total = this.allContactsData.length;
            } else {
                console.error("No data available to update pagination.");
            }
        },

        handlePageChange(newPage) {
            // Update the current page and paginate the data
            this.pagination.currentPage = newPage;
            this.paginateContacts();
        },

        formatDate1(dateProp) {
            return (row, column, cellValue, index) => {
                if (!cellValue) return "";
                const [year, month, day] = cellValue.split("-");
                return `${day}-${month}-${year}`;
            };
        },
        formatDate2(dateProp) {
            return (row, column, cellValue, index) => {
                if (!cellValue) return "";
                // Split the date and time if present
                const [datePart, timePart] = cellValue.split(" "); // Split into date and time
                const [year, month, day] = datePart.split("-");
                return `${day}-${month}-${year} ${timePart}`;
            };
        },
        loadDates() {
            const currentYear = new Date().getFullYear();
            const startYear = 2022;
            const years = [];

            for (let year = startYear; year <= currentYear; year++) {
                years.push(year.toString());
            }

            this.dates.listeDates = years;
            this.dates.selectedYear = currentYear.toString();
        },

        handleYearChange() {
            // this.getGainAndSpend();
            this.contactsData = [];
            this.fetchContacts();
        },
        handleProductChange() {
            // this.getGainAndSpend();
            this.contactsData = [];
            this.pagination.currentPage = 1
            this.fetchContacts();
        },
        resetExpandGraphChart(){
            //console.log(this.chartArray.length)
            this.chartArray.forEach((item, index) => {
                item.isExpanded = false;
            })
        },
        handleEmailClick(email) {
            // Construct the URL you want to open in a new tab
            const url = this.$router.resolve({
                path: "/weedodata/admin/VerifEmail",
                query: { email: email },
            }).href;

            // Open the new URL in a new tab
            window.open(url, "_blank");
        },
        handleYearChangeIndex(index) {
            this.chartArray[index].loading = false
            this.resetExpandGraphChart();
            console.log("change for", index);

               /*  this.chartArray[index].loading = true;
                    this.loading = true; */
                    this.chartArray[index].contacts = this.allData[this.chartArray[index].selectedYear];
                    // Appeler les fonctions pour mettre à jour les graphiques
                    this.contacts = this.chartArray[index].contacts;
                    this.chartArray[index].mixedChartData =
                        this.getFilteredChartData(
                            "mixedChartData1",
                            this.chartArray[index].selectedProduct,
                            this.chartArray[index].selectedOperation,
                            this.chartArray[index].levier,
                            this.chartArray[index].selectedYear,
                            this.chartArray[index].contacts,
                            index
                        );
                this.chartArray[index].loading = true

        },
        getFilteredChartData(
            chartDataKey,
            selectedProduct,
            selectedOperation,
            levier,
            selectedYear,
            contacts,
            index
        ) {
            // Define the date range for the current year
            const startOfYear = moment(`${selectedYear}-01-01`);
            let endOfYear = moment(`${selectedYear}-12-31`);
            if (selectedYear == moment().year()) {
                // Si c'est l'année actuelle, on va jusqu'à la fin du mois courant
                endOfYear = moment(
                    `${selectedYear}-${moment().month() + 1}-01`
                ).endOf("month");
            }

            // Normalize the selected values
            const selectedProductNormalized =
                (selectedProduct && selectedProduct.trim().toLowerCase()) || "";
            const selectLevierNormalized =
                (levier && levier.trim().toLowerCase()) || "";

            // Filter contacts based on product and operation
            const filteredContacts = Array.isArray(contacts)
                ? contacts.filter((contact) => {
                      const contactDate = moment(contact.date, "YYYY-MM");
                      const contactProductNormalized =
                          (contact.categorie &&
                              contact.categorie.trim().toLowerCase()) ||
                          "";
                      const contactLevier =
                          (contact.levier &&
                              contact.levier.trim().toLowerCase()) ||
                          "";

                      const matchesProduct =
                          selectedProductNormalized === "" ||
                          selectedProductNormalized === "tous" ||
                          contactProductNormalized ===
                              selectedProductNormalized;

                      const matchesLevier =
                          selectLevierNormalized === "" ||
                          selectLevierNormalized === "tous" ||
                          contactLevier === selectLevierNormalized;

                      return matchesProduct && matchesLevier;
                  })
                : [];

            // Log filtered contacts to debug

            // Prepare data for charts
            const labels = [];
            const CACData = [];
            const CACData_past = [];
            const CACData_actuel = [];

            const LTVData = [];
            const LTVData_past = [];
            const LTVData_actuel = [];
            const LTV_CACData = [];
            let currentMonth = startOfYear.clone();
            while (currentMonth.isSameOrBefore(endOfYear, "month")) {
                const monthKey = currentMonth.format("YYYY-MM");

                // Filter data for the current month
                const monthData = filteredContacts.filter(
                    (contact) =>
                        moment(
                            contact.annee + "-" + contact.mois,
                            "YYYY-MM"
                        ).format("YYYY-MM") === monthKey
                );

                let totalCAC = 0;
                let totalCAC_past = 0;
                let totalCAC_actuel = 0;
                let totalLTV = 0;
                let totalLTV_past = 0;
                let totalLTV_actuel = 0;

                if (selectedOperation == "mer") {
                    monthData.forEach((contact) => {
                        totalCAC += parseFloat(contact.total_depense_past + contact.total_depense_actuel) || 0;
                        totalCAC_past +=
                            parseFloat(contact.total_depense_past) || 0;
                        totalCAC_actuel +=
                            parseFloat(contact.total_depense_actuel) || 0;
                        totalLTV += parseFloat(contact.gains_mer_past + contact.gains_mer_actuel) || 0;
                        totalLTV_past +=
                            parseFloat(contact.gains_mer_past) || 0;
                        totalLTV_actuel +=
                            parseFloat(contact.gains_mer_actuel) || 0;
                    });
                } else if (selectedOperation == "vente") {
                    monthData.forEach((contact) => {
                        totalCAC += parseFloat(contact.total_depense_past + contact.total_depense_actuel) || 0;
                        totalCAC_past +=
                            parseFloat(contact.total_depense_past) || 0;
                        totalCAC_actuel +=
                            parseFloat(contact.total_depense_actuel) || 0;
                        totalLTV += parseFloat(contact.gains_vente_past + contact.gains_vente_actuel) || 0;
                        totalLTV_past +=
                            parseFloat(contact.gains_vente_past) || 0;
                        totalLTV_actuel +=
                            parseFloat(contact.gains_vente_actuel) || 0;
                    });
                } else if (
                    selectedOperation == "Tout" ||
                    selectedOperation == ""
                ) {
                    monthData.forEach((contact) => {
                        totalCAC += parseFloat(contact.total_depense_past + contact.total_depense_actuel) || 0;
                        totalCAC_past +=
                            parseFloat(contact.total_depense_past) || 0;
                        totalCAC_actuel +=
                            parseFloat(contact.total_depense_actuel) || 0;
                        totalLTV += parseFloat(contact.gains_mer_past + contact.gains_mer_actuel + contact.gains_vente_past + contact.gains_vente_actuel) || 0;
                        totalLTV_past +=
                            parseFloat(
                                contact.gains_mer_past +
                                    contact.gains_vente_past
                            ) || 0;
                        totalLTV_actuel +=
                            parseFloat(
                                contact.gains_mer_actuel +
                                    contact.gains_vente_actuel
                            ) || 0;
                    });
                }

                labels.push(monthKey);


                //console.log(monthKey);
                /* console.log(totalLTV_past);
                console.log(totalLTV_actuel); */
                //console.log(totalLTV);
                /* console.log(totalCAC_past);
                console.log(totalCAC_actuel);
                console.log(totalCAC);
                */
               const currentMonthFormatted = moment().format("YYYY-MM");
                if(monthKey === currentMonthFormatted){
                    this.ca_mois_actuel = totalLTV;
                    /* console.log('monthKey', monthKey)
                    console.log('total_LTV', totalLTV)
                    console.log('this.ca_mois_actuel', this.ca_mois_actuel) */
                }
                CACData.push(totalCAC);
                CACData_past.push(totalCAC_past);
                CACData_actuel.push(totalCAC_actuel);
                //LTVData2.push(totalLTV);
                LTVData.push(totalLTV);
                LTVData_past.push(totalLTV_past);
                LTVData_actuel.push(totalLTV_actuel);
                LTV_CACData.push(
                    totalCAC === 0
                        ? 0
                        : (totalLTV_past + totalLTV_actuel) / totalCAC
                );
                //}

                currentMonth.add(1, "month");
            }
            const total_LTV_CAC = LTV_CACData.reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0
            );
            const total_LTV = LTVData.reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0
            );
            this.moyenne_LTV_CAC[index] = this.formatThounsends(
                total_LTV_CAC / labels.length,
                true,
                2
            );
            this.moyenne_total_LTV[index] = this.formatThounsends(total_LTV / labels.length, true, 2)
           /*  console.log("LTVData", LTVData);
            console.log("CACData", CACData); */
            //console.log("LTV_CACData", LTV_CACData);
            const maxValueLTV = Math.max(...LTVData);
            const maxValueCAC = Math.max(...CACData);
            this.maxValueActuel = Math.max(maxValueLTV, maxValueCAC);
            this.chartArray[index].maxValue = this.maxValueActuel;
            if(this.maxValue <= this.maxValueActuel){
                this.maxValue = this.maxValueActuel
            }
            this.chartOptions1.scales.yAxes[0].ticks.suggestedMax = this.maxValue
            this.updateAllCharts();

            //console.log(selectedProduct)

            /* if(selectedProduct == 'per'){
                this.maxValue = 120
                this.chartOptions1.scales.yAxes[0].ticks.suggestedMax = this.maxValue
                this.updateAllCharts();
            } */
            //console.log('this.maxValue', this.maxValue)

            // Return formatted data for the chart
            return {
                labels: labels,
                datasets: [
                    {
                        type: "bar",
                        label: "Coût d'Acquisition Client (CAC)",
                        backgroundColor: "rgba(	241, 143, 1)",
                        borderColor: "rgb(241, 143, 1)",
                        borderWidth: 2,
                        shadowColor: "rgba(0, 0, 0, 0.2)", // Couleur de l'ombre
                        shadowBlur: 10, // Flou de l'ombre
                        shadowOffsetX: 3,
                        shadowOffsetY: 3, // Décalage vertical de l'ombre
                        borderWidth: 1,
                        data: CACData_actuel,
                        order: 2,
                        stack: "stack2",
                    },
                    {
                        type: "bar",
                        label: "Coût d'Acquisition Client (CAC Antérieur)",
                        backgroundColor: "rgba(179, 30, 30)",
                        //borderColor: "rgb(1.2, 37.3, 56.1)",
                        borderColor: "rgb(1.2, 37.3, 56.1)",
                        borderWidth: 2,
                        //shadowColor: "rgba(0, 0, 0, 0.2)",
                        shadowColor: "rgb(0, 0, 0, 0.2)",
                        shadowBlur: 10,
                        shadowOffsetX: 3,
                        shadowOffsetY: 3,
                        borderWidth: 1,
                        data: CACData_past,
                        order: 2,
                        stack: "stack2",
                    },
                    {
                        type: "bar",
                        label: "Lifetime Value (LTV)",
                        backgroundColor: "rgba(	4, 139, 168)",
                        borderColor: "rgb(1.2, 37.3, 56.1)",
                        borderWidth: 2,
                        shadowColor: "rgba(0, 0, 0, 0.2)",
                        shadowBlur: 10,
                        shadowOffsetX: 3,
                        shadowOffsetY: 3,
                        borderWidth: 1,
                        data: LTVData_actuel,
                        order: 2,
                        stack: "stack1",
                    },
                    {
                        type: "bar",
                        label: "Lifetime Value (LTV Antérieur)",
                        //backgroundColor: "rgba(179, 30, 30)",
                        backgroundColor: "rgba(1, 110, 50)",
                        //borderColor: "rgb(1.2, 37.3, 56.1)",
                        borderColor: "rgb(1.2, 37.3, 56.1)",
                        borderWidth: 2,
                        //shadowColor: "rgba(0, 0, 0, 0.2)",
                        shadowColor: "rgb(0, 0, 0, 0.2)",
                        shadowBlur: 10,
                        shadowOffsetX: 3,
                        shadowOffsetY: 3,
                        borderWidth: 1,
                        data: LTVData_past,
                        order: 2,
                        stack: "stack1",
                    },
                    {
                        type: "line",
                        label: "LTV/CAC",
                        borderColor: "rgba(220, 218, 300, 0.25)",
                        fill: false,
                        data: LTV_CACData,
                        yAxisID: "y-axis-2",
                        order: 1,
                    },
                    {
                        type: "line",
                        label: "Repère",
                        borderColor: "red",
                        borderWidth: 2, // Thicker line for better visibility
                        borderDash: [5, 5], // Dashed line style
                        pointRadius: 0, // Remove points on the line
                        data: new Array(labels.length).fill(1.0), // Create an array with 1.0 for each label
                        yAxisID: "y-axis-2",
                        order: 0,
                        lineTension: 0, // Straight lines instead of curves
                        borderJoinStyle: "miter", // Rounded line joins
                        borderCapStyle: "round", // Rounded line caps
                    },
                ],
            };
        },

        searchByEmail(isValidationClick = false) {
            if (this.searchEmail.trim() === "") {
                // Si la recherche est vide, réinitialiser à toutes les données affichées
                this.contactsData = [...this.allContactsData];
                this.updatePagination();
            } else {
                const emailSearch = this.searchEmail.trim().toLowerCase();
                // Recherche locale dans les données actuellement affichées (contactsData)
                const filteredLocalData = this.contactsData.filter((contact) =>
                    contact.email.toLowerCase().includes(emailSearch)
                );

                if (filteredLocalData.length > 0) {
                    // Si l'email existe localement, afficher les résultats filtrés
                    this.contactsData = filteredLocalData;
                    this.updatePagination();
                } else {
                    if (isValidationClick) {
                        this.fetchContacts(true);
                    }
                }
            }
        },

        handleInputChange() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (!this.searchEmail) {
                    this.clearSearch();
                }
            }, 300); // Délai de 300 ms avant d'appeler clearSearch
        },
        clearSearch() {
            this.searchEmail = "";
            this.contactsData = [...this.allContactsData];
            this.fetchContacts();
            this.updatePagination();
            this.paginateContacts();
        },

        /* filterContacts() {
          this.pagination.currentPage = 1; // Reset to the first page on filter change
          this.fetchContacts(); // Fetch filtered contacts
        },*/
    },

    mounted() {
        this.allowChatBot = JSON.parse(localStorage.getItem('utilisateur')).email == "a.gorani@weedoit.fr" ||
                            JSON.parse(localStorage.getItem('utilisateur')).email == "s.boukbir@weedoit.fr" ||
                            JSON.parse(localStorage.getItem('utilisateur')).email == "k.ghalem@weedoit.fr" ||
                            JSON.parse(localStorage.getItem('utilisateur')).email == "n.khallouki@weedoit.fr"
        //this.chartArray.push(this.i)

        //  this.getGainAndSpend();
        this.loadDates();

        this.filteredContacts = this.leads;
        this.pagination.total = this.filteredContacts.length;
        this.fetchContacts();
    },
    created() {
        this.loading = true;
        this.fetchChartAllData()

        // this.fetchContactsDebounced = debounce(this.fetchContacts, this.debounceTime);
        /*  this.fetchGraphData1();
        this.fetchGraphData2();
        this.fetchGraphData3();
        this.fetchGraphData4(); */
        // this.fetchContacts();
    },

    watch: {
        searchEmail() {
            this.searchByEmail(); // Appeler la recherche lorsqu'un email est entré
        },

        // Watcher pour les changements de page dans la pagination
        "pagination.currentPage": function (newPage) {
            // Lorsqu'une nouvelle page est sélectionnée, récupérez les contacts pour cette page
            this.paginateContacts();
        },

        // Watcher pour d'autres modifications de pagination si nécessaire (ex: nombre d'éléments par page)
        /* 'pagination.perPage': function (newSize) {
        // Réinitialiser à la première page lorsque la taille de la pagination change
        this.pagination.currentPage = 1;
        this.fetchContacts();
        }*/
    },
};
</script>

<style scoped>
::v-deep .el-table .index-column {
    color: #6c757d !important;
}
.content {
    padding: 20px;
}

.card-chart {
    margin: 20px 0;
}
.chart-container {
    margin-bottom: 20px;
    margin-left: 40px;
    margin-right: 20px; /* Adjust the margin as needed */
    /* background-color: #171c2b;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(24, 21, 21, 0.1); */
}
#card-body1 {
    padding: 20px;
    margin-right: -14px;
}
#card-body2 {
    padding: 20px;
    margin-left: -12px;
}
#card-bodydate {
    margin-left: 0.5px;
}

.chart-area {
    width: 100%;
    /*min-height: 300px;*/
    position: relative;
}

.mix {
    width: 100%;
    height: 100%;
}
#couleur {
    background-color: #d0d0e9;
}
.loading-container {
    position: relative;
}

.el-icon-circle-close {
    cursor: pointer;
    color: #b5b9c2;
}
.el-tooltip .el-tooltip__popper {
    max-width: 300px;
}
#search {
    margin-left: 66%;
}

.el-icon-info {
    font-size: 18px;
    cursor: pointer;
    color: #b5b9c2;
}
.el-icon-check {
    position: absolute;
    right: 8px;
    top: 35%;
    color: #b5b9c2;
}
.chart-legend {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
    color: #b5b9c2;
}
#icon-info {
    margin-left: 98%;
    color: #b5b9c2;
}
</style>
